@if (!!administrator) {

  <!-- Define our administrator menu. -->
  <button mat-button [matMenuTriggerFor]="administratorMenu">
    <avvvatars [displayValue]="(administrator.firstName[0] + administrator.lastName[0]).toUpperCase()"
               [value]="administrator.emailAddress"></avvvatars>
    &nbsp;
    {{ administrator.firstName }} {{ administrator.lastName }}
    <mat-icon matButtonIcon iconPositionEnd>expand_more</mat-icon>
  </button>

  <!-- Define our administrator menu items. -->
  <mat-menu #administratorMenu="matMenu">

    <!-- Settings -->
    <button mat-menu-item (click)="openSettingsDialog()">
      <mat-icon matButtonIcon="">settings</mat-icon>
      Settings
    </button>

    <!-- Sign-Out -->
    <button mat-menu-item routerLink="/admin/sign-out">
      <mat-icon matButtonIcon="">logout</mat-icon>
      Sign&dash;Out
    </button>
  </mat-menu>
}
